import {
  GetOnEvaluationHoursError,
  GetOnEvaluationHoursSuccess,
  PostReportQuickSendToClientError,
  PostReportQuickSendToClientSuccess,
  getApprovesTeamsReportError,
  getApprovesTeamsReportSuccess,
  getHoursReportError,
  getHoursReportSuccess,
  getRejectsTeamsReportError,
  getRejectsTeamsReportSuccess,
  getUserTeamsReportError,
  getUserTeamsReportSuccess,
  screenVerifiedError,
  screenVerifiedSuccess,
  togglePageLoader,
  workReportsError,
  workReportsSuccess,
} from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"
// Login Redux States
import {
  getHoursReports,
  get_EvaluationHours,
  post_ApprovesTeams,
  post_RejectsTeams,
  post_ReportQuickSendToClient,
  post_UserTeams,
  post_teams_workreports,
  submit_reports_selected_teams,
  update_bookmarks,
} from "helpers/backend_helper"
import {
  APPROVES_TEAMS,
  EVALUATION_HOURS,
  GET_HOURS_REPORT,
  REJECTS_TEAMS,
  REPORT_QUICK_SEND_TO_CLIENT,
  SEND_REPORT_FOR_SELECTED_PROJECT,
  UPDATE_BOOK_MARKS_LISTS,
  USER_TEAMS,
  WORK_REPORTS,
} from "./actionType"

function* getTeamsReport({ payload: teams }) {
    try {
    yield put(togglePageLoader(true))
    const response = yield call(post_UserTeams, teams)
    if (response.statusCode === 200) {
      yield put(getUserTeamsReportSuccess(response.data))
       yield put(togglePageLoader(false))
    } else {
      yield put(getUserTeamsReportError(response))
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getUserTeamsReportError(error))
    yield put(togglePageLoader(false))
  }
}

function* getApprovesReport({ payload: data }) {
    try {
    yield put(togglePageLoader(true))
    const response = yield call(post_ApprovesTeams, data)
    if (response.statusCode === 200) {
      yield put(getApprovesTeamsReportSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      const delay = time => new Promise(resolve => setTimeout(resolve, time))
      yield call(delay,6000)
      yield put(getApprovesTeamsReportSuccess({}))
      yield put(togglePageLoader(false))
    } else {
      yield put(getApprovesTeamsReportError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getApprovesTeamsReportError(error))
    yield put(togglePageLoader(false))
  }
}

function* getRejectsReport({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_RejectsTeams, data)
    if (response.statusCode === 200) {
      yield put(getRejectsTeamsReportSuccess(response))
      toast.success(response.message)
      yield put(togglePageLoader(false))
      const delay = time => new Promise(resolve => setTimeout(resolve, time))
      yield call(delay,6000)
      yield put(getRejectsTeamsReportSuccess({}))
      yield put(togglePageLoader(false))
    } else {
      yield put(getRejectsTeamsReportError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getRejectsTeamsReportError(error))
    yield put(togglePageLoader(false))
  }
}
function* getWorkReports({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_teams_workreports, data)
    if (response.statusCode === 200) {
      yield put(workReportsSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      yield put(workReportsError(response))
      toast.error(response)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(workReportsError(error))
    toast.error(error?.response ? error.response.data.message : error)
    yield put(togglePageLoader(false))
  }
}

function* sendReportsforSelectedProject({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(submit_reports_selected_teams, data)
    if (response.statusCode === 200) {
      yield put(togglePageLoader(false))
      callback("SUCCESS")
      toast.success(response?.message)
    } else {
      toast.error(response)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response.data.message : error)
    yield put(togglePageLoader(false))
  }
}

function* getEvalutionHoursforTeams({ payload: data }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(get_EvaluationHours, data)
    if (response.statusCode === 200) {
      yield put(GetOnEvaluationHoursSuccess(response))
      yield put(togglePageLoader(false))
    } else {
      toast.error(response)
      GetOnEvaluationHoursError(response)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response.data.message : error)
    GetOnEvaluationHoursError(error)
    yield put(togglePageLoader(false))
  }
}

// send report to client
function* postReportQuickSendToClients({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(post_ReportQuickSendToClient, data)
    if (response.statusCode === 200) {
      yield put(PostReportQuickSendToClientSuccess(response))
      yield put(togglePageLoader(false))
      callback("SUCCESS")
      toast.success(response?.message)
    } else {
      yield put(PostReportQuickSendToClientError(response))
      yield put(togglePageLoader(false))
      toast.error(response?.message)
    }
  } catch (error) {
    yield put(PostReportQuickSendToClientError(error))
    yield put(togglePageLoader(false))
  }
}
//get hours report list employee
function* getHoursReportList({ payload: params, exports,exportname }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(getHoursReports, params, exportname)
    if (exports !== "export") {
      if (response.statusCode === 200) {
        yield put(getHoursReportSuccess(response))
        yield put(togglePageLoader(false))
      } else {
        yield put(getHoursReportError(response))
        toast.error(response.message)
        yield put(togglePageLoader(false))
      }
    } else {
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    yield put(getHoursReportError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
  }
}


// send report to client
function* UpdateBookMarkedLists({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(update_bookmarks, data)
    if (response.statusCode === 200) {
      yield put(togglePageLoader(false))
      toast.success(response?.message)
      callback()
    } else {
      yield put(togglePageLoader(false))
      toast.error(response?.message)
    }
  } catch (error) {
    yield put(togglePageLoader(false))
  }
}
function* teamsSaga() {
  yield takeEvery(USER_TEAMS, getTeamsReport)
  yield takeEvery(APPROVES_TEAMS, getApprovesReport)
  yield takeEvery(REJECTS_TEAMS, getRejectsReport)
  yield takeEvery(WORK_REPORTS, getWorkReports)
  yield takeEvery(
    SEND_REPORT_FOR_SELECTED_PROJECT,
    sendReportsforSelectedProject
  )
  yield takeEvery(EVALUATION_HOURS, getEvalutionHoursforTeams)
  yield takeEvery(REPORT_QUICK_SEND_TO_CLIENT, postReportQuickSendToClients)
  yield takeEvery(GET_HOURS_REPORT, getHoursReportList)
  yield takeEvery(UPDATE_BOOK_MARKS_LISTS, UpdateBookMarkedLists)  
}

export default teamsSaga
